export const OPTIMAL_BREAK_POINT_MOBILE = 668;
export const SIDE_TYPE = {
  left: 'LEFT',
  right: 'RIGHT',
};
